import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import { get, patch } from "../../../../server/actions";
import ReactTable from 'react-table';
import Modal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import 'react-table/react-table.css';
import $ from 'jquery';
import ToggleDisplay from 'react-toggle-display';
import { BeatLoader } from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import "../../../../../node_modules/react-datetime/css/react-datetime.css";
import { _addNotificationError, _addNotification } from "../../../../server/util";
import moment from 'moment';
let pathUrl = '';
let _menuList = [];
let itemName = '';
let restoreItemName = '';
let restoreCol = {};
let menuItemId = 0;
const customMenuItemsStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
class MenuMasterList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            menuMasterList: [],
            search: '',
            show: false,
            modalIsOpen: false,
            modalRestoreIsOpen: false
        }
        this.getMealItems = this.getMealItems.bind(this);
        this.edit_masterMenu = this.edit_masterMenu.bind(this);
    }
    componentWillMount = () => {
        this.getMealItems();
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        pathUrl = sessionStorage.getItem('ROLE') === 'ROLE_CATERER' ? '/caterer' : '/schoolAdmin'
    }
    getMealItems = () => {
        let schoolId = sessionStorage.getItem('SchoolId');
        this.setState({ loading: true })
        get('/menuItems/search/findMenuItemsBySchool?schoolId=' + schoolId + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let _menuItems = data._embedded.menuItems || [];
            this.setState({ loading: false, menuMasterList: _menuItems });
            _menuList = _menuItems;
        }).catch(
            (error) => {
                this.setState({ loading: false })
                console.log('Get SchoolDistricts response', error)
            }
        );
    }
    filterData = (e, value) => {
        e.preventDefault();
        if ((value !== '') && (_menuList.length > 0)) {
            this.setState({ menuMasterList: _menuList.filter(item => item.category === value) });
        } else {
            this.setState({ menuMasterList: _menuList });
        }
    }
    edit_masterMenu = (row) => {
        let id = 0;
        if (row) {
            id = row._links.self.href.split('/').pop();
            this.context.router.history.push(pathUrl + '/menuMaster/' + id);
        }
    }
    handleClick() {
        this.setState({
            show: !this.state.show
        })

    }
    openModal(props) {
        itemName = props.original.name;
        if (props.original) {
            menuItemId = props.original._links.self.href.split('/').pop();
        }
        this.setState({ modalIsOpen: true });

    }
    restoreMenuItem = (col) => {
        this.setState({ modalRestoreIsOpen: true });
        restoreItemName = col.name;
        restoreCol = col;
    }
    restoreMenuItems = () => {
        if (restoreCol) {
            menuItemId = restoreCol._links.self.href.split('/').pop();
        }
        this.deleteMenu('restore')
    }
    deleteMenu = (status) => {
        this.setState({ loading: true });
        let request = {};
        if (status === 'delete') {
            request = { active: false };
        } else {
            request = { active: true };
        }
        patch(`/menuItems/${menuItemId}?access_token=`, JSON.stringify(request)).then((response) => {
            if (response.status == 200) {
                this.setState({ loading: false });
                if (status === 'delete') {
                    _addNotification('Menu item deleted successfully.', this);
                    this.setState({ modalIsOpen: false });
                } else {
                    _addNotification('Menu item restored successfully.', this);
                    this.setState({ modalRestoreIsOpen: false });
                }
                this.getMealItems();
            } else if (!response.ok) {
                throw Error(response.statusMessage);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false })
                console.log('Get MenuItems response', error.message)
                _addNotificationError(error.message, this);
            }
        );
    }
    render() {
        const nutritionInfo = {
            color: "white",
            padding: "10px",
            background: "rgb(234, 112, 102)",
            marginTop: "5px",
        }
        {
            $('#selector button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
                // TODO: insert whatever you want to do with $(this) here
            })
        }
        return (
            <Fragment>
                <section className=" full-width clearfix">
                    <div className='sweet-loading'
                        style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <NotificationSystem ref="notificationSystem" />
                    <div className="container">
                        <div className="row">
                            <div className="sectionTitle col-md-4">
                                <h2>Master Menu Item</h2>
                            </div>
                            <div className="col-md-8" style={{ marginTop: '15px' }}>
                                <div id="selector"
                                    className="btn-group pull-right"
                                    style={{ margin: '5px 0' }}>
                                    <button type="button"
                                        className="btn btn-xs btn-inactive-color active"
                                        style={{ margin: 0, marginLeft: 3, fontSize: 12 }}
                                        onClick={(e) => this.filterData(e, '')}>All
                                </button>
                                    <button type="button" className="btn btn-xs btn-inactive-color"
                                        name="Breakfast" id="breakfast" style={{ margin: 0, marginLeft: 3, fontSize: 12 }}
                                        onClick={(e) => this.filterData(e, 'BREAKFAST')}>
                                        Breakfast</button>
                                    <button type="button" className="btn btn-xs btn-inactive-color"
                                        name="Lunch" style={{ margin: 0, marginLeft: 3, fontSize: 12 }}
                                        onClick={(e) => this.filterData(e, 'MEAL')}>
                                        Lunch</button>
                                    <button type="button" className="btn btn-xs btn-inactive-color"
                                        name="Dinner" style={{ margin: 0, marginLeft: 3, fontSize: 12 }}
                                        onClick={(e) => this.filterData(e, 'DINNER')}>
                                        Dinner</button>
                                    <button type="button" className="btn btn-xs btn-inactive-color"
                                        name="Snack" style={{ margin: 0, marginLeft: 3, fontSize: 12 }}
                                        onClick={(e) => this.filterData(e, 'SNACK')}>
                                        Snack</button>
                                </div>
                            </div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="panel panel-primary">
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <input placeholder="Search.."
                                            className="form-control"
                                            style={{ margin: '5px 0px' }}
                                            type="text"
                                            value={this.state.search}
                                            onChange={(e) => {
                                                this.setState({ search: e.target.value })
                                            }} />
                                    </div>
                                    <div className="col-md-9 text-right">
                                        <button
                                            className="btn btn-success btn-sm"
                                            style={{ margin: '0', fontSize: '14px' }}
                                            onClick={() => {

                                                this.props.history.push(pathUrl + '/menuMaster');
                                            }}><i class="fa fa-plus"></i> Add Menu Item</button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ReactTable
                                            data={this.state.menuMasterList.filter(val => val.active === true).filter((item => {
                                                if ((this.state.search || '') === '') {
                                                    return true;
                                                } else {
                                                    if (item.name.toUpperCase().includes(this.state.search.toUpperCase())) {
                                                        return true;
                                                    }
                                                    if (item.longDescription.toUpperCase().includes(this.state.search.toUpperCase())) {
                                                        return true;
                                                    }
                                                    if (item.allergens.toUpperCase().includes(this.state.search.toUpperCase())) {
                                                        return true;
                                                    }
                                                    return false;
                                                }
                                            }))}
                                            columns={[
                                                {
                                                    Header: 'Item Name',
                                                    accessor: 'name',
                                                    //style: { textAlign: 'center', verticalAlign:'middle' },
                                                    Cell: (props) => (
                                                        <Fragment>
                                                            <a className="btn-linkedin-link" style={{ padding: '0px', cursor: 'pointer' }}
                                                                data-tip data-for={'std-' + props.index}>
                                                                {props.value}</a>
                                                            <ReactTooltip id={'std-' + props.index} aria-haspopup='true' place="right" type="success" effect="solid">
                                                                <div className="nutrition-info-tooltip">
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <h4 className="nutrition-info-header" style={{ marginBottom: '5px' }}>Nutrition Facts - (Calories {props.original.calories || 0})</h4>
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <div className="nutrition_item">Total Fat (g) <span className="nutrition_item_right">{props.original.totalFat || 0}</span></div>
                                                                            <div className="nutrition_item">Saturated Fat (g) <span className="nutrition_item_right">{props.original.saturatedFat || 0}</span></div>
                                                                            <div className="nutrition_item">Trans Fat (g) </div>
                                                                            <div className="nutrition_item">Polyunsaturated Fat (g) </div>
                                                                            <div className="nutrition_item">Monounsaturated Fat (g) </div>
                                                                            <div className="nutrition_item">Cholesterol (mg) <span className="nutrition_item_right">{props.original.cholestral || 0}</span></div>
                                                                            <div className="nutrition_item">Sodium (mg) <span className="nutrition_item_right">{props.original.sodium || 0}</span></div>
                                                                            <div className="nutrition_item">Total Carbohydrate (g) <span className="nutrition_item_right">{props.original.totalCarbohydrate || 0}</span></div>
                                                                            <div className="nutrition_item">Dietary Fiber (g) <span className="nutrition_item_right">{props.original.dietaryFiber || 0}</span></div>
                                                                            <div className="nutrition_item">Total Sugars (g) </div>
                                                                            <div className="nutrition_item">Includes Added Sugars (g) <span className="nutrition_item_right">{props.original.sugars || 0}</span></div>
                                                                            <div className="nutrition_item">Sugar Alcohol (g) </div>
                                                                            <div className="nutrition_item">Protein (g) <span className="nutrition_item_right">{props.original.protein || 0}</span></div>
                                                                            <div className="nutrition_item">Vitamin D (mcg) <span className="nutrition_item_right">{props.original.vitaminD || 0}</span></div>
                                                                            <div className="nutrition_item">Calcium (mg) <span className="nutrition_item_right">{props.original.calcium || 0}</span></div>
                                                                            <div className="nutrition_item">Iron (mg) <span className="nutrition_item_right">{props.original.iron || 0}</span></div>
                                                                            <div className="nutrition_item">Potassium (mg) <span className="nutrition_item_right">{props.original.potassium || 0}</span></div>
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <div className="nutrition_item">Vitamin A (mcg) <span className="nutrition_item_right">{props.original.vitaminA || 0}</span></div>
                                                                            <div className="nutrition_item">Vitamin C (mcg) <span className="nutrition_item_right">{props.original.vitaminC || 0}</span></div>
                                                                            <div className="nutrition_item">Vitamin E (mcg) <span className="nutrition_item_right">{props.original.vitaminE || 0}</span></div>
                                                                            <div className="nutrition_item">Vitamin K (mcg) <span className="nutrition_item_right">{props.original.vitaminK || 0}</span></div>
                                                                            <div className="nutrition_item">Thiamin (mg) <span className="nutrition_item_right">{props.original.thiamin || 0}</span></div>
                                                                            <div className="nutrition_item">Riboflavin (mg) <span className="nutrition_item_right">{props.original.riboFlavin || 0}</span></div>
                                                                            <div className="nutrition_item">Niacin (mg) <span className="nutrition_item_right">{props.original.niacin || 0}</span></div>
                                                                            <div className="nutrition_item">Vitamin B6 (mg) <span className="nutrition_item_right">{props.original.vitaminB6 || 0}</span></div>
                                                                            <div className="nutrition_item">Folate DFE (mcg) <span className="nutrition_item_right">{props.original.folate || 0}</span></div>
                                                                            <div className="nutrition_item">Vitamin B12 (mcg) <span className="nutrition_item_right">{props.original.vitaminB12 || 0}</span></div>
                                                                            <div className="nutrition_item">Pantothenic Acid (mg) <span className="nutrition_item_right">{props.original.pantothenicAcid || 0}</span></div>
                                                                            <div className="nutrition_item">Phosphorus (mg) <span className="nutrition_item_right">{props.original.phosphorous || 0}</span></div>
                                                                            <div className="nutrition_item">Magnesium (mg) <span className="nutrition_item_right">{props.original.magnesium || 0}</span></div>
                                                                            <div className="nutrition_item">Zinc (mg) <span className="nutrition_item_right">{props.original.zinc || 0}</span></div>
                                                                            <div className="nutrition_item">Selenium (mcg) <span className="nutrition_item_right">{props.original.selenium || 0}</span></div>
                                                                            <div className="nutrition_item">Copper (mg) <span className="nutrition_item_right">{props.original.copper || 0}</span></div>
                                                                            <div className="nutrition_item">Manganese (mg) <span className="nutrition_item_right">{props.original.manganese || 0}</span></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ReactTooltip>
                                                        </Fragment>
                                                    )
                                                },
                                                {
                                                    Header: 'Description',
                                                    accessor: 'longDescription',
                                                    Cell: props => <span>{props.value}</span>
                                                },
                                                {
                                                    Header: 'Allergens',
                                                    accessor: 'allergens',
                                                    Cell: props => <span>{props.value}</span>

                                                },
                                                {
                                                    Header: 'Action',
                                                    Id: 'action',
                                                    style: { textAlign: 'center' },
                                                    width: 100,
                                                    Cell: props => {
                                                        return (<Fragment>
                                                            <a title="Click to edit menu." href="javascript:void(0);"
                                                                onClick={() => {
                                                                    this.edit_masterMenu(props.original);
                                                                }}>
                                                                <i className="fa fa-pencil-square-o tbl-rounded-icon bg-color-1 fa-icon"></i>
                                                            </a>
                                                            <a title="Delete info" href="javascript:void(0);" onClick={() => this.openModal(props)}><i
                                                                className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon" /></a>
                                                        </Fragment>)
                                                    }
                                                }]}
                                            defaultPageSize={10}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <p className="App-intro">
                                    <a href="javascript:void(0);" onClick={() => this.handleClick()}> Inactive
                                    Items
                                        </a>
                                </p>
                                <ToggleDisplay show={this.state.show}>
                                    <p><b><i> These are the deleted items. Click on restore to undo the
                                            action.</i></b>
                                        {/*<span className="pull-right"><a>Restore all</a></span>*/}</p>
                                    <div className="table-responsive ">
                                        <table className="table table-dark" id="schoolData">
                                            <thead>
                                                <tr className="bg-success base-reverse">
                                                    <th>Item Name</th>
                                                    <th>Description</th>
                                                    <th>Allergens</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.menuMasterList.map(col => {
                                                        if (!col.active)
                                                            return (<tr>
                                                                <td>{col.name}</td>
                                                                <td>{col.longDescription}</td>
                                                                <td>{col.allergens}</td>
                                                                <td className="actions text-center" style={{ whiteSpace: 'nowrap' }}>
                                                                    <div>
                                                                        <a href="javascript:void(0);"
                                                                            onClick={() => this.restoreMenuItem(col)}>Restore
                                                                                </a>
                                                                    </div>
                                                                </td>
                                                            </tr>)
                                                    })
                                                }

                                            </tbody>
                                        </table>

                                    </div>
                                </ToggleDisplay>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    style={customMenuItemsStyles}
                >
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color col-md-10" id="deleteLabel">Delete
                                            Menu Item</h4>
                        <div className="col-md-2"><button type="button" className="pull-right color-1" onClick={() => this.setState({ modalIsOpen: false })}>X</button></div>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to delete this menu item <b><i>'{itemName}'</i></b> from Meal Manage service?<br />
                            <b><i>You can restore menu item again from deleted items tab</i></b></p>
                    </div>
                    <div className="modal-footer">
                        <form>
                            <button type="button" className="btn btn-sm btn-success"
                                onClick={() => this.setState({ modalIsOpen: false })}
                                style={{ margin: 0, fontSize: 14 }}><i
                                    className="glyphicon glyphicon-remove" /> Cancel
                                            </button>
                            <button type="button" className="btn btn-sm btn-danger"
                                onClick={() => this.deleteMenu('delete')}
                                style={{ margin: 0, marginLeft: 5, fontSize: 14 }}><i
                                    className="glyphicon glyphicon-ok" /> Delete
                                            </button>
                        </form>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.modalRestoreIsOpen}
                    onAfterOpen={this.afterRestoreOpenModal}
                    // onRequestClose={this.closeRestoreModal}
                    style={customMenuItemsStyles}
                    contentLabel="Activation"
                >
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color col-md-10" id="deleteLabel">Restore
                                            Menu Item</h4>
                        <div className="col-md-2"><button type="button" className="pull-right color-1" onClick={() => this.setState({ modalRestoreIsOpen: false })}>X</button></div>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to restore this menu item <b><i>'{restoreItemName}'</i></b></p>
                    </div>
                    <div className="modal-footer">
                        <form>
                            <button type="button" className="btn btn-sm btn-success"
                                onClick={() => this.setState({ modalRestoreIsOpen: false })}
                                style={{ margin: 0, fontSize: 14 }}><i
                                    className="glyphicon glyphicon-remove" /> Cancel
                                            </button>
                            <button type="button" className="btn btn-sm btn-danger"
                                onClick={this.restoreMenuItems}
                                style={{ margin: 0, marginLeft: 5, fontSize: 14 }}><i
                                    className="glyphicon glyphicon-ok" /> Restore
                                            </button>
                        </form>
                    </div>
                </Modal>
            </Fragment>)
    }
}
MenuMasterList.contextTypes = {
    router: PropTypes.object.isRequired
}
export default MenuMasterList



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Caterer/MenuMaster/menuMasterList.jsx